import React from 'react';
import { isEmpty, isFinite } from 'lodash';
import DataSinksTable from 'js/components/data_sinks/DataSinksTable';
import NoContentTextView from 'js/components/elements/NoContentTextView';
import { CONTACT_SUPPORT_LINK } from 'js/constants/config';
import { SUPPORT_KEY_SINK_LIST } from 'js/constants/supportPageKeys';
import {
  ACLQueryModeTypes,
  AvailableFilterTypesByView,
  SearchFilterViews,
} from 'js/constants/visibilityFilters';
import RoutePrefixContext from 'new/contexts/RoutePrefixContext';
import { BannerDescription } from 'new/elements/BannerDescription';
import ResourceEditProvider from 'js/components/ResourceEditProvider';

const description =
  'Specify your preferred output for Nexla data, such as databases, cloud storage, or APIs. \nDestinations are created with Nexsets and can be deleted if unlinked.';

const availableFilterTypes = AvailableFilterTypesByView[SearchFilterViews.DATA_SINKS];

class ViewDataSinks extends React.Component {
  static contextType = RoutePrefixContext;

  componentDidMount() {
    this.props.setContextualSupport(SUPPORT_KEY_SINK_LIST);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.sinkId && prevProps.sinkId !== this.props.sinkId) {
      this.props.loadDataSink(this.props.sinkId, ACLQueryModeTypes.MODE_COLLABORATOR.key);
    }
  }

  componentWillUnmount() {
    this.props.unsetContextualSupport(SUPPORT_KEY_SINK_LIST);
  }

  render() {
    const { sinks, allSinks, sinkId, isLoading, getSourceMeta, loadMyDataSinks } = this.props;
    const singleItemMode = isFinite(sinkId) ? true : false;

    let noContentView = null;

    if (!isLoading && isEmpty(allSinks)) {
      if (singleItemMode === true) {
        noContentView = (
          <NoContentTextView
            title={<div>We are sorry, we could not find this destination</div>}
            subtitle={
              <div>
                Please reload the page or file a{' '}
                <a style={{ color: '#507fe7' }} href={CONTACT_SUPPORT_LINK}>
                  support ticket
                </a>{' '}
                to request support.
              </div>
            }
          />
        );
      } else {
        noContentView = (
          <NoContentTextView
            title={<div>Send data to your first destination by configuring a Nexset</div>}
            subtitle={
              <div>
                File a{' '}
                <a style={{ color: '#507fe7' }} href={CONTACT_SUPPORT_LINK}>
                  support ticket
                </a>{' '}
                to request support
              </div>
            }
          />
        );
      }
    }

    return (
      <ResourceEditProvider>
        <div>
          <BannerDescription
            title={this.props.title || 'Destinations'}
            description={this.props.description || description}
            rightView={this.props.rightView}
          />
          <div>
            <DataSinksTable
              view={SearchFilterViews.DATA_SINKS}
              urlId={sinkId}
              isLoading={isLoading}
              data={sinks}
              isSelection={this.props.isSelection}
              onSelectionChange={this.props.onSelectionChange}
              getSourceMeta={getSourceMeta}
              availableFilterTypes={availableFilterTypes}
              loadData={loadMyDataSinks}
              noContentView={noContentView}
            />
          </div>
        </div>
      </ResourceEditProvider>
    );
  }
}

ViewDataSinks.defaultProps = {
  onlyTableView: false,
};

export default ViewDataSinks;
